export const apiKey='4c5739b0da6cefd7734590674846548a8e08';
export const db='pubmed';
export const retmode='json';
export const retmax='10';
